import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { ClientsOnboardingQuery, PagingResultModelOfClientModel, GetClientsInput, OrderDirection, ClientOrderByInput, ClientStatus } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const QUERY_CLIENTS_ONBOARDING = gql`
  query clientsOnboarding($input: GetClientsInput!) {
    clients(input: $input) {
      cursor {
        nextPage
        previousPage
      }
      totalCount
      nodes {
        name
        id
        statusCode
        lastModifiedBy
        lastModifiedByName
        lastModifiedTime
      }
    }
  }
`;

export const queryClientsOnboarding = async (
    client: ApolloClient<NormalizedCacheObject>,
    after?: string | undefined,
    limit?: number | undefined,
): Promise<PagingResultModelOfClientModel | undefined> => {
    const order: ClientOrderByInput = { lastModifiedTime: OrderDirection.Desc, name: OrderDirection.Asc };
    const { data, errors } = await client.query<ClientsOnboardingQuery>({
        query: QUERY_CLIENTS_ONBOARDING,
        variables: {
            input: {
                after: after,
                limit: limit,
                order: order,
                statusCodes: [ClientStatus.Onboarding],
            }
        }
    });

    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console.
            console.error(error);
        });
        // Friendly error to the user.
        throw new Error('An error has occurred during the query.');
    }

    return data?.clients as PagingResultModelOfClientModel;
};